module.exports = __webpack_public_path__ + "img/2.08bf5a96.png";